module.exports = __webpack_public_path__ + "img/sphere01-graph.da1ff4d5.png";